export default "__VITE_ASSET__ZGJQ5wHK__"